import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsShipmentManagementServices } from "../../../../APIServices/EIWRS/ShipmentManagement/eiwrsShipmentManagementServices";
import { eiwrsSiteInventoryServices } from "../../../../APIServices/EIWRS/eiwrsSiteInventoryServices";

const UpdateStudySiteShipment = ({
  shipmentData,
  getStudySiteShipmentData,
  Show,
  Hide,
  Title,
  siteList,
  corierList,
  setShipmentId,
}) => {
  const { studyId } = useParams()
  const [siteId, setSiteId] = useState("");
  const [depotId, setDepotId] = useState("");
  const [shipmentType, setShipmentType] = useState("");
  const [corierId, setCorierId] = useState("");
  const [depotList, setDepotList] = useState([]);
  const [totalKit, setTotalKit] = useState([]);
  const [trackingId, setTrackingId] = useState("");
  const [tempLoggerId, setTempLoggerId] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const updateStudySiteShipment = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Study Site Shipment!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = shipmentData?._id;
        userData.studyId = studyId;
        userData.shipmentType = shipmentType;
        userData.corierId = corierId;
        userData.trackingId = trackingId;
        userData.tempLoggerId = tempLoggerId;
        userData.mode = StudyMode;
        let data = await eiwrsShipmentManagementServices.updateStudySiteShipment(
          userData
        );
        if (data?.statusCode === 200) {
          getStudySiteShipmentData();
          Hide();
        }
      }
      setButtonLoader(false);
    });
  };

  const getDepotBySite = async () => {
    let data = await eiwrsSiteInventoryServices.getDepotBySite(studyId, siteId)
    setDepotList(data?.data || [])
  }

  useEffect(() => {
    if (siteId) {
      getDepotBySite()
    }
  }, [siteId]);

  useEffect(() => {
    setSiteId(shipmentData?.siteId);
    setDepotId(shipmentData?.depotId);
    setShipmentType(shipmentData?.shipmentType);
    setCorierId(shipmentData?.corierId);
    setTrackingId(shipmentData?.trackingId);
    setTotalKit(shipmentData?.kitList || []);
    setTempLoggerId(shipmentData?.tempLoggerId);
  }, [shipmentData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Site <abbr className="text-danger">*</abbr>
            </Form.Label>
            <Form.Select
              value={siteId}
              disabled
              onChange={(e) => setSiteId(e.target.value)}
            >
              <option value="">
                Select Site
              </option>
              {siteList?.map((item, index) => (
                <option key={index} value={item.siteId}>
                  {item.row?.SITEID}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Depot <abbr className="text-danger">*</abbr>
            </Form.Label>
            <Form.Select
              value={depotId}
              disabled
              onChange={(e) => setDepotId(e.target.value)}
            >
              <option value="">
                Select Depot
              </option>
              {depotList?.map((item, index) => (
                <option key={index} value={item.depotId}>
                  {item.row?.DEPOTID}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          {depotId &&
            <Form.Group className="mb-1">
              <Form.Label className="mb-1 fw-bold">
                Kits <abbr className="text-danger">*</abbr>
              </Form.Label>
              {totalKit?.map((item) => (
                <Form.Check
                  key={item?.kitId}
                  type="checkbox"
                  checked
                  disabled
                  label={`${item?.kitNumber}${item?.columns?.filter(
                    (column) => column?.isUnique === "yes"
                  )?.length > 0
                    ? ` (${item?.columns
                      ?.filter((column) => column?.isUnique === "yes")
                      ?.map(
                        (data) => `${data?.columnName}: ${data?.columnValue}`
                      )
                      ?.join(", ")})`
                    : ""
                    }`}
                />
              ))}
            </Form.Group>
          }
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Shipiment Type <abbr className="text-danger">*</abbr>
            </Form.Label>
            <Form.Select
              value={shipmentType}
              onChange={(e) => setShipmentType(e.target.value)}
            >
              <option value="">
                Select Shipiment Type
              </option>
              <option value="initial">Initial shipment</option>
              <option value="resupply">Resupply shipment</option>
              <option value="emergency">Emergency shipment</option>
              <option value="replacement">Replacement shipment</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Corier
            </Form.Label>
            <Form.Select
              value={corierId}
              onChange={(e) => setCorierId(e.target.value)}
            >
              <option value="">
                Select Corier
              </option>
              {corierList?.map((item, index) => (
                <option key={index} value={item.corierId}>
                  {item.row?.CORIERID}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Tracking / AWB No.{" "}
            </Form.Label>
            <Form.Control
              onChange={(e) => setTrackingId(e.target.value)}
              value={trackingId}
              className="br3"
              placeholder="Enter Tracking / AWB No."
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Temp logger Id{" "}
            </Form.Label>
            <Form.Control
              onChange={(e) => setTempLoggerId(e.target.value)}
              value={tempLoggerId}
              className="br3"
              placeholder="Enter Temp logger Id"
              type="text"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={
              shipmentData?.status === "pending" ?
                (!siteId || !depotId || !shipmentType || buttonLoader)
                : (!shipmentType || buttonLoader)}
            className="updateProfile"
            onClick={(e) => updateStudySiteShipment(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              "Update Shipment"
            )}
          </button>
        </div>
      </Offcanvas >
    </>
  );
};

export default UpdateStudySiteShipment;
